const BASE_LEN = 65;
const MARGIN = 3;

export default [
  {
    x: 0,
    y: 0,
    w: 4,
    h: 2,
    i: "0",
    width: BASE_LEN * 4 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF',
    }
  },
  {
    x: 2,
    y: 2,
    w: 4,
    h: 2,
    i: "1",
    width: BASE_LEN * 4 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#228b22',
    }
  },
  {
    x: 0,
    y: 4,
    w: 4,
    h: 2,
    i: "2",
    width: BASE_LEN * 4 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#AD46E0',
    }
  },
  {
    x: 4,
    y: 0,
    w: 2,
    h: 2,
    i: "3",
    width: BASE_LEN * 2 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#9400d3'
    }
  },
  {
    x: 4,
    y: 4,
    w: 2,
    h: 2,
    i: "4",
    width: BASE_LEN * 2 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#ffa07a'
    }
  },
  {
    x: 0,
    y: 2,
    w: 2,
    h: 2,
    i: "5",
    width: BASE_LEN * 2 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF'
    }
  },
  {
    x: 0,
    y: 6,
    w: 2,
    h: 2,
    i: "6",
    width: BASE_LEN * 2 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF'
    }
  },
  {
    x: 2,
    y: 6,
    w: 4,
    h: 2,
    i: "7",
    width: BASE_LEN * 4 - MARGIN * 2,
    height: BASE_LEN * 2 - MARGIN * 2,
    rotateX: 0,
    faceStyle: {
      'background-color': '#1E90FF'
    }
  }
]
